import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SpinnerService } from '@core/services/spinner.service';
import { MyApplicationForUi } from '@core/typings/application.typing';
import { ApplicationStatuses } from '@core/typings/status.typing';
import { ApplicationEligibilityService } from '@features/application-eligibility/application-eligibility.service';
import { ApplicationApplicantService } from '@features/apply/application-applicant.service';
import { TableRepository, TableRepositoryFactory } from '@yourcause/common';
import { AnalyticsService, EventType } from '@yourcause/common/analytics';
import { YCModalComponent } from '@yourcause/common/modals';
import { ArrayHelpersService } from '@yourcause/common/utils';

interface CopyApplicationModalResponse {
  goBack: boolean;
  startNew: boolean;
  appToCopy: MyApplicationForUi;
}
@Component({
  selector: 'gc-copy-application-modal',
  templateUrl: './copy-application-modal.component.html',
  styleUrls: ['./copy-application-modal.component.scss']
})
export class CopyApplicationModalComponent extends YCModalComponent<
  CopyApplicationModalResponse
> implements OnInit {
  @Input() programId: number;
  @Input() programName: string;
  @Input() isNomination = false;

  hide = false;
  repository: TableRepository<MyApplicationForUi>;

  constructor (
    private autoTableFactory: TableRepositoryFactory,
    private applicationApplicantService: ApplicationApplicantService,
    private arrayHelper: ArrayHelpersService,
    private analyticsService: AnalyticsService,
    private spinnerService: SpinnerService,
    private applicationEligibilityService: ApplicationEligibilityService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit () {
    const rows = this.arrayHelper.sort(
      this.applicationApplicantService.myApplications.filter((app) => {
      return +this.programId === +app.grantProgramId &&
        app.status !== ApplicationStatuses.Draft;
      }),
      'submissionDate',
      true
    );
    this.repository = this.autoTableFactory.create({
      key: `AVAILABLE_TO_COPY_${this.programId}`,
      columns: [],
      rows,
      skipAddToState: true,
      changeDetectorRef: this.changeDetectorRef
    });
  }

  async copyApplication (application: MyApplicationForUi) {
    this.spinnerService.startSpinner();
    this.hide = true;
    const valid = await this.applicationEligibilityService.checkCopyEligibilityForApplicantView(
      application.applicationId,
      application.grantProgramId,
      this.isNomination,
      application.organizationId
    );
    this.spinnerService.stopSpinner();
    if (valid) {
      this.closeModal.emit({
        goBack: false,
        startNew: false,
        appToCopy: application
      });
    } else {
      this.goBack();
    }
  }

  startNew () {
    this.closeModal.emit({
      goBack: false,
      startNew: true,
      appToCopy: null
    });
    this.analyticsService.emitEvent({
      eventName: 'Start new',
      eventType: EventType.Click,
      extras: null
    });
  }

  goBack () {
    this.closeModal.emit({
      goBack: true,
      startNew: false,
      appToCopy: null
    });
    this.analyticsService.emitEvent({
      eventName: 'Go back',
      eventType: EventType.Click,
      extras: null
    });
  }
}
